import { createFileRoute, useRouterState, Link, Outlet } from "@tanstack/react-router";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@quake/shared-ui/components/ui/tabs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/apps")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageLayout>
      <Outlet />
    </PageLayout>
  );
}

function PageLayout({ children }: { children: React.ReactNode }) {
  const { datasetSlug } = Route.useParams();
  const routerState = useRouterState();
  const pathname = routerState.location.pathname;
  const currentTab = pathname.includes("/apps/syncs/writebacks")
    ? "writebacks"
    : pathname.includes("/apps/syncs")
      ? "syncs"
      : pathname.includes("/apps/installed")
        ? "installed"
        : "apps";

  return (
    <Tabs value={currentTab}>
      <div className="px-4 space-y-1">
        <div className="flex gap-4">
          <h1 className="text-3xl font-bold tracking-tight">Apps</h1>
          <TabsList>
            <TabsTrigger value="apps" asChild>
              <Link to="/$datasetSlug/apps" params={{ datasetSlug }}>
                Available Apps
              </Link>
            </TabsTrigger>
            <TabsTrigger value="installed" asChild>
              <Link to="/$datasetSlug/apps/installed" params={{ datasetSlug }}>
                Installed Apps
              </Link>
            </TabsTrigger>
            <TabsTrigger value="syncs" asChild>
              <Link to="/$datasetSlug/apps/syncs" params={{ datasetSlug }}>
                Sync Ops
              </Link>
            </TabsTrigger>
            <TabsTrigger value="writebacks" asChild>
              <Link to="/$datasetSlug/apps/syncs/writebacks" params={{ datasetSlug }}>
                Writebacks
              </Link>
            </TabsTrigger>
          </TabsList>
        </div>
        <p className="text-muted-foreground">Manage your apps and connector syncs.</p>
      </div>
      <TabsContent value={currentTab} className="container mx-auto p-4">
        {children}
      </TabsContent>
    </Tabs>
  );
}
